(function detectUserAgent() {
  var D = document;
  var root = D.documentElement;

  // Detect User Agent
  var ua = window.navigator.userAgent;
  var platform = window.navigator.platform;
  var windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];

  // ! Detect Browsers & OS
  // Opera 8.0+
  var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || ua.indexOf(' OPR/') >= 0;
  // Firefox 1.0+
  var isFirefox = typeof InstallTrigger !== 'undefined';
  // Safari 3.0+ "[object HTMLElementConstructor]" 
  var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
  // Internet Explorer 6-11
  var isIE = /*@cc_on!@*/false || !!D.documentMode;
  // Edge 20+
  var isEdge = !isIE && !!window.StyleMedia;
  // Chrome 1 - 71
  var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
  // Blink engine detection
  var isBlink = (isChrome || isOpera) && !!window.CSS;

  // OS
  var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  var isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
  var isIOS = /(iPhone|iPod|iPad)/i.test(navigator.platform);
  var isWindows = windowsPlatforms.indexOf(platform) !== -1;
  var isLinux = /Linux/.test(platform);

  // Detect Browsers
  if (isOpera) root.classList.add('is-opera');
  else if (isFirefox) root.classList.add('is-firefox');
  else if (isSafari) root.classList.add('is-safari');
  else if (isIE) root.classList.add('is-ie');
  else if (isEdge) root.classList.add('is-edge');
  else if (isChrome) root.classList.add('is-chrome');
  else if (isBlink) root.classList.add('is-blink');

  // Detect OS
  if (isMac) root.classList.add('is-mac');
  else if (isMacLike) root.classList.add('is-mac-like');
  if (isWindows) root.classList.add('is-windows');
  if (isLinux) root.classList.add('is-linux');
  if (isIOS) root.classList.add('is-ios');

  //Detect Mobile Device OS
  if (ua.match(/Android/i)) root.classList.add('is-android');
  if (ua.match(/webOS/i)) root.classList.add('is-webos');
  if (ua.match(/iPhone/i)) root.classList.add('is-iphone');
  if (ua.match(/iPod/i)) root.classList.add('is-ipod');
  if (ua.match(/iPad/i)) root.classList.add('is-ipad');
  if (ua.match(/Windows Phone/i)) root.classList.add('is-windows-phone');
  if (ua.match(/SymbianOS/i)) root.classList.add('is-symbian');
  if (ua.match(/RIM/i) || ua.match(/BB/i)) root.classList.add('is-blackberry');

  // Detect iOS Safari (Since Chrome on iOS is too familiar)
  // ? https://stackoverflow.com/questions/3007480/determine-if-user-navigated-from-mobile-safari/29696509#29696509
  (function DetectIosSafari(){
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    var iOS_Safari = iOS && webkit && !ua.match(/CriOS/i);
    if (iOS_Safari) root.classList.add('is-ios-safari');
  })();

  (function iosVersion() {
    let v, versions;
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
      // supports iOS 2.0 and later: &lt;http://bit.ly/TJjs1V&gt;
      v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
      versions = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
      return versions[0];
      // D.getElementsByTagName('html')[0].classList.add('ios-' + versions);
    } else {
      return 0;
    }
  })();

  if (window.ActiveXObject !== undefined){
    if (!window.XMLHttpRequest) root.classList.add('is-ie-6');
    else if (!D.querySelector) root.classList.add('is-ie-7');
    else if (!D.addEventListener) root.classList.add('is-ie-8');
    else if (!window.atob) root.classList.add('is-ie-9');
    else if (!D.__proto__) root.classList.add('is-ie-10');
  }

  (function DetectiPhones(window){

    // Really basic check for the ios platform
    // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    // Get the device pixel ratio
    var ratio = window.devicePixelRatio || 1;

    // Define the users device screen dimensions
    var screen = {
      width : window.screen.width * ratio,
      height : window.screen.height * ratio
    };

    // iPhone X Detection
    if (iOS && screen.width == 1125 && screen.height === 2436) {

      // Set a global variable now we've determined the iPhoneX is true
      window.iphoneX = true;

      // Adds a listener for ios devices that checks for orientation changes.
      window.addEventListener('orientationchange', update);
      update();
    }

    // Each time the device orientation changes, run this update function
    function update() {
      notch();
      iphoneXChecker();
    }

    // Notch position checker
    function notch() {

      var _notch = '';

      if( 'orientation' in window ) {
        // Mobile
        if (window.orientation == 90) {
          _notch = 'left';
        } else if (window.orientation == -90) {
          _notch = 'right';
        }
      } else if ( 'orientation' in window.screen ) {
        // Webkit
        if( screen.orientation.type === 'landscape-primary') {
          _notch = 'left';
        } else if( screen.orientation.type === 'landscape-secondary') {
          _notch = 'right';
        }
      } else if( 'mozOrientation' in window.screen ) {
        // Firefox
        if( screen.mozOrientation === 'landscape-primary') {
          _notch = 'left';
        } else if( screen.mozOrientation === 'landscape-secondary') {
          _notch = 'right';
        }
      }

      window.notch = _notch;
    }

  })(window);

  // Bespoke functions:
  // The above functions have no jQuery Dependencies.
  // The below code uses jQuery solely for this quick demo.
  if ( window.iphoneX === true ) {
    D.documentElement.classList.add('iphoneX');
  }
  
  (function iphoneXChecker() {
    if (window.notch == 'left') {
      D.documentElement.classList.add('is-notch-right')
      D.documentElement.classList.add('is-notch-left');
    } else if (window.notch == 'right') {
      D.documentElement.classList.add('is-notch-left')
      D.documentElement.classList.add('is-notch-right');
    } else {
      D.documentElement.classList.add('is-notch-right');
      D.documentElement.classList.add('is-notch-left');
    }
  })();
})();